var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-drawer',{attrs:{"title":"页面样式设置","visible":_vm.show,"size":"240px","direction":_vm.direction,"before-close":_vm.handleClose},on:{"update:visible":function($event){_vm.show=$event}}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }